<template>
  <div>
    <v-container style="margin-left: 15px">
      <v-container class="pa-1 chat-fondo" style="min-height: 480px">
        <v-item-group v-model="selected">
          <v-row v-if="!ocultarModulos">
            <v-col
              v-for="item in items"
              :key="item.ruta"
              cols="12"
              sm="12"
              md="6"
              lg="3"
            >
              <v-hover v-slot:default="{ hover }" open-delay="200">
                <v-card
                  :elevation="hover ? 24 : 0"
                  class="card-borde-azul"
                  @click="obtenerRuta(item.ruta, item.rol)"
                >
                  <v-img height="150" :src="require(`../.././assets/${item.img}.png`)">
                  </v-img>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-item-group>
      </v-container>
      <v-snackbar v-model="snackbar" :timeout="timeout" color="light-blue darken-4" shaped centered top>
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="cyan lighten-5" text v-bind="attrs" @click="snackbar = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
    <audio v-if="estado == '1'" autoplay loop>
      <source src="../../assets/alerta-sonido.mp3" type="audio/mp3" />
    </audio>
    <v-dialog fullscreen v-model="alertDialog" persistent>
      <v-card
        color="rgba(255,0,0,0.4)"
        style="display: flex; align-items: center; justify-content: center"
      >
        <div
          style=' border: 5px solid white; display: flex; align-items: center; flex-direction: column; justify-content: center; height: 550px; width: 550px; color: white; background-color: red; font-size: 2em; padding: 1em;'
        >
          <img
            class="mb-7 mr-8"
            src="../../assets/warning.gif"
            style="height: 200px; width: 200px"
            alt=""
          />
          <p>se activo la alarma de <strong>¡PANICO!</strong></p>
          <p><strong>ip: </strong>{{ ipActual }}</p>
          <p><strong>municipio: </strong>{{ municipioActual }}</p>
          <p><strong>punto: </strong>{{ puntoActual }}</p>
          <v-btn style="height: 3em; width: 5em" @click="parar()">ok</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="pedirZona" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          Actualizacion de información.
        </v-card-title>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="zonaSelect"
                  :items="zonas"
                  item-text="nombreZona"
                  item-value="idZona"
                  outlined
                  dense
                  chips
                  small-chips
                  :rules="[(v) => !!v || 'Se requiere seleccionar una zona']"
                  label="Selecciona la zona donde labora actualmente"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="actualizarZona"
              :disabled="!valid"
            >
              Actualizar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import env from "../env";
export default {
  data: () => ({
    id: localStorage.getItem("idCargo"),
    cedula: localStorage.getItem("cedula"),
    idCargo: localStorage.getItem("idCargo"),
    identificador: localStorage.getItem("id"),
    alertDialog: false,
    items: [],
    alertas: [],
    selected: [],
    snackbar: false,
    text: "",
    estado: 0,
    ipActual: "",
    idPanico: "",
    municipioActual: "",
    puntoActual: "",
    idActual: "",
    show: false,
    zonaSelect: "",
    zonas: [],
    dialog: true,
    dialog1: false,
    valid: true,
    timeout: 9000,
    pedirZona: false,
    pedirContrasena: false,
    ocultarModulos: true,

    defaultItem: {
      idUsuario: "",
      contrasena: "",
      contrasena2: "",
    },
    userModified: {},
    editedItem: {
      idUsuario: "",
      contrasena: "",
      contrasena2: "",
    },
  }),
  mounted() {
    this.obtenerUsuarios();
    this.obtenerApps();
    // 🆕 Funcionalidad de pánico deshabilitada - ya no se necesita
    // this.panico();
    // if (this.idCargo == "15" || this.idCargo == "29") {
    //   setInterval(() => {
    //     this.panico();
    //   }, 10000);
    // }
  },
  methods: {
    // Metodo para obtener las alertas
    // 🆕 Funcionalidad deshabilitada - ya no se necesita
    panico() {
      // Funcionalidad deshabilitada
      return;
      // axios.get(`${env.endpoint}callcenter/panico`).then((res) => {
      //   this.alertas = res.data;
      //   res.data.map((item) => {
      //     item.estado === "1" ? this.confirmacion(item) : null;
      //   });
      // });
    },
    parar() {
      this.estado = 0;
      this.dialog1 = false;
      axios
        .get(
          `${env.endpoint}callcenter/panicoAtencion?idPanico=${this.idPanico}`
        )
        .then((res) => (this.report = res.data));
      this.$router.push("/User/Panico");
    },
    //metodo para abrir modal de alerta
    confirmacion(alerta) {
      this.estado = alerta.estado;
      this.ipActual = alerta.ip;
      this.idPanico = alerta.idPanico;
      this.municipioActual = alerta.municipio;
      this.puntoActual = alerta.punto;
      this.idActual = alerta.idPanico;

      if (this.estado === "1") {
        this.alertDialog = true;
        //console.log("alerta");
      }
    },
    obtenerUsuarios() {
      // 🆕 Validar que identificador existe y es válido antes de hacer la petición
      const id = this.identificador;
      if (!id || id === 'null' || id === 'undefined' || id === '' || id === null || id === undefined) {
        console.warn('No se puede obtener usuario: identificador no válido', { identificador: id });
        // 🆕 Si no hay identificador válido, mostrar las cards de todas formas
        this.ocultarModulos = false;
        return;
      }
      
      // 🆕 Convertir a número y validar que sea un número válido
      const idNumero = parseInt(id);
      if (isNaN(idNumero) || idNumero <= 0) {
        console.warn('No se puede obtener usuario: identificador no es un número válido', { identificador: id });
        // 🆕 Si el identificador no es válido, mostrar las cards de todas formas
        this.ocultarModulos = false;
        return;
      }
      
      axios
        .get(`${env.endpoint}user/infoUSuario?id=${idNumero}`)
        .then((res) => {
          // 🆕 Validar que res.data existe y tiene al menos un elemento
          if (res.data && res.data.length > 0 && res.data[0]) {
            this.validarZona(res.data[0]);
          } else {
            // 🆕 Si no hay datos del usuario, mostrar las cards de todas formas
            this.ocultarModulos = false;
          }
        })
        .catch((error) => {
          // 🆕 Solo mostrar error si no es un 404 por id inválido
          if (error.response && error.response.status === 404) {
            console.warn('Usuario no encontrado (404). Verificar que el ID sea válido:', idNumero);
          } else {
            console.error('Error al obtener usuario:', error);
          }
          // 🆕 Si hay un error al obtener el usuario, mostrar las cards de todas formas
          this.ocultarModulos = false;
        });
    },
    validarZona(usuario) {
      // 🆕 Validar que usuario existe antes de acceder a sus propiedades
      if (!usuario) {
        // Si no hay usuario, mostrar las cards de todas formas
        this.ocultarModulos = false;
        return;
      }
      
      const appPermitidas = this.items;
      // 🆕 Si no hay apps permitidas aún, esperar a que se carguen
      if (!appPermitidas || appPermitidas.length === 0) {
        // Mostrar las cards de todas formas si no hay apps para validar
        this.ocultarModulos = false;
        return;
      }
      
      let tempModulos = false;
      appPermitidas.forEach((e) => {
        if (
          e.nombreApp == "CALLCENTER" &&
          e.rol == "asesor" &&
          usuario.idZona == 0
        ) {
          this.pedirZona = true;
          tempModulos = true;
        }
      });

      if (!tempModulos) this.ocultarModulos = false;
    },
    actualizarZona() {
      if (this.$refs.form.validate()) {
        const datosAsignacionZona = JSON.stringify({
          zona: this.zonaSelect,
          asesor: this.identificador,
        });
        axios.get(`${env.endpoint}user/asignarZonaAsesor?data=${datosAsignacionZona}`)
          .then((res) => {
            this.text = "Asignación de zona, registrada con éxito.";
            this.snackbar = true;
            this.zonaSelect = "";
            this.pedirZona = false;
            this.ocultarModulos = false;
          })
          .catch((e) => {
            this.text =
              "Ha ocurrido un error, intente de nuevo, si el problema persiste comuníquese con el área de sistemas.";
            this.snackbar = true;
          });
      } else {
        this.text =
          "Por favor seleccione un valor, de lo contrario no podra actualizar.";
      }
    },
    obtenerApps() {
      axios
        .get(`${env.endpoint}user/permisosUser?id=${this.id}`)
        ///.then((res) => (this.items = res.data));
        .then((res) => {
          this.items = res.data;
          // 🆕 Si no hay items o la lista está vacía, mostrar las cards de todas formas
          if (!this.items || this.items.length === 0) {
            this.ocultarModulos = false;
          }
        })
        .catch((error) => {
          console.error('Error al obtener apps:', error);
          // 🆕 Si hay un error al obtener las apps, mostrar las cards de todas formas
          this.ocultarModulos = false;
        });
    },
    obtenerRuta(ruta, rol) {
  // La tabla login fue eliminada, ahora navegamos directamente
  // Verificar si la ruta es externa (URL completa)
  if (ruta.startsWith("http://") || ruta.startsWith("https://")) {
    window.location.href = ruta; // Redirigir a URL externa
  } else {
    // Validación para rutas internas específicas
    switch (ruta) {
      case `${env.ip}/callcenter/`:
        this.$router.push("/callcenter");
        break;
      case `${env.ip}/callcenter/asesor`:
        this.$router.push("/callcenter/asesor");
        break;
      case `${env.ip}/callcenter/reportes`:
        this.$router.push("/callcenter/reportes");
        break;
      case `${env.ip}/callcenter/especialista`:
        this.$router.push("/callcenter/especialista");
        break;
      case `${env.ip2}/visitasNew/Usuario/RegistraVisita`:
        this.$router.push(`/visitasNew/Usuario/RegistraVisita?id=${localStorage.getItem('id')}`);
        break;
      default:
        this.$router.push(ruta); // Navegar dentro de la SPA
    }
  }
},
    updateZona() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.dialog = false;
      } else {
        this.text = "Debe seleccionar una zona";
        this.snackbar = true;
      }
    },

    /**
     * Metodo para actualizar contraseña
     */
    validarContrasena() {
      if (this.editedItem.contrasena != this.editedItem.contrasena2) {
        (this.snackbar = true), (this.text = "Las contraseñas no coinciden");
      } else {
        if (this.editedItem.contrasena.length >= 8) {
          var mayuscula = false;
          var minuscula = false;
          var numero = false;
          var caracter_raro = false;

          for (var i = 0; i < this.editedItem.contrasena.length; i++) {
            if (
              this.editedItem.contrasena.charCodeAt(i) >= 65 &&
              this.editedItem.contrasena.charCodeAt(i) <= 90
            ) {
              mayuscula = true;
            } else if (
              this.editedItem.contrasena.charCodeAt(i) >= 97 &&
              this.editedItem.contrasena.charCodeAt(i) <= 122
            ) {
              minuscula = true;
            } else if (
              this.editedItem.contrasena.charCodeAt(i) >= 48 &&
              this.editedItem.contrasena.charCodeAt(i) <= 57
            ) {
              numero = true;
            } else {
              caracter_raro = true;
            }
          }
          if (
            mayuscula == true &&
            minuscula == true &&
            caracter_raro == true &&
            numero == true
          ) {
            const usuario = JSON.stringify({
              idUsuario: this.identificador,
              contrasena: this.editedItem.contrasena,
            });
            axios
              .get(
                `${env.endpoint}user/modificar_contrasena?usuario=${usuario}`
              )
              .then((res) => {
                if (res.data.mensaje === "usuario actualizado") {
                  (this.snackbar = true),
                    (this.text = "usuario actualizado satisfactoriamente");
                  this.pedirContrasena = false;
                } else if (res.data.mensaje === "error en la actualizacion") {
                  (this.snackbar = true),
                    (this.text = "Error en la actualización");
                }
              });
          } else {
            var text = "Debe contener";
            if (!mayuscula) {
              text = text + " Minimo 1 mayúscula  -  ";
            }
            if (!minuscula) {
              text = text + "  - Minimo 1 minuscula";
            }
            if (!caracter_raro) {
              text = text + " - Minimo 1 caracter especial";
            }
            if (!numero) {
              text = text + " - Minimo 1 número ";
            }
            this.text = text;
            this.snackbar = true;
          } // obtiene los datos del arreglo para poder actualizar el usuario en el modal
        } else {
          (this.snackbar = true),
            (this.text = "Contraseña minimo 8 caracteres");
          this.editedItem.contrasena = "";
        }
      }
    },
  },
};
</script>
<style scoped>
.tab1 {
  background-image: linear-gradient(180deg, #294697 20%, #1D3C7F 100%);
  width: 100%;
  color: white !important;
}
.card-borde-azul {
  background: linear-gradient(135deg, #1D3C7F, #294697);
  padding: 4px;
  border-radius: 20px;
  display: inline-block; /* o block si es necesario */
}

.card-contenido {
  background: white; /* o el color del contenido */
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(41, 70, 151, 0.1);
  transition: box-shadow 0.3s;
}

.card-borde-azul:hover .card-contenido {
  box-shadow: 0 8px 32px rgba(29, 60, 127, 0.2);
}

/* Responsive para tablet en modo horizontal - 2 cards por fila */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .v-container .v-row .v-col.col-sm-12.col-md-6.col-lg-3 {
    flex: 0 0 50% !important;
    max-width: 50% !important;
    padding: 8px !important;
  }
  
  .v-container .v-row .v-col .v-card {
    margin: 12px auto !important;
    max-width: 320px !important;
    width: 100% !important;
  }
  
  .v-container .v-row .v-col .v-img {
    height: 180px !important;
  }
  
  .v-container .v-row {
    justify-content: center !important;
  }
}

/* Responsive para tablet en modo vertical - 1 card por fila */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .v-container .v-row .v-col.col-sm-12.col-md-6.col-lg-3 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 12px !important;
    width: 100% !important;
  }
  
  .v-container .v-row .v-col .v-card {
    margin: 20px auto !important;
    max-width: 500px !important;
    width: 90% !important;
    height: auto !important;
    min-height: 350px !important;
  }
  
  .v-container .v-row .v-col .v-img {
    height: 320px !important;
    width: 100% !important;
  }
  
  .v-container.pa-1 {
    padding: 20px !important;
  }
  
  .v-container .v-row {
    justify-content: center !important;
  }
}
</style>
